<template>
    <div class="pagination-wrapper">
      <button @click="prevGroup" class="pagination-button" :disabled="!visiblePrevButton">이전</button>
      <div class="page-wrapper">
        <span class="page" v-for="page in displayedPages" :key="page">
            <button @click="goToPage(page)" :class="{ 'active': currentPageNo === page }">{{ page }}</button>
        </span>
      </div>
      <button @click="nextGroup" class="pagination-button" :disabled="!visibleNextButton">다음</button>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      total: {
        type: Number,
        required: true
      },
      currentPageNo: {
        type: Number,
        required: true
      },
      pageSize: {
        type: Number,
        required: true
      },
      limit: {
        type: Number,
        required: false,
        default: 10,
      }
    },
    computed: {
      totalPage() {
        return Math.ceil(this.total / this.pageSize); // 총 페이지 수 계산
      },
      pageGroup() {
        return Math.ceil(this.currentPageNo / this.limit);  // 현재 페이지 그룹 계산
      },
      lastPageNo() {
        let pageNo = this.pageGroup * this.limit;
        if(pageNo > this.totalPage) {
            pageNo = this.totalPage;
        }
        return pageNo;
      },
      firstPageNo() {
        let pageNo = (this.pageGroup - 1)  * this.limit + 1;

        return pageNo
      },
      displayedPages() {
        const pages = [];
        for(let i = this.firstPageNo; i <= this.lastPageNo; i++) {
            pages.push(i);
        }
        
        // 검색 결과가 없어서 페이지가 표시되지 않을 때 기본으로 1은 표시되도록 함
        if(pages.length === 0) {
          pages.push(1);
        }
        return pages;
      },
      visiblePrevButton() {
        return this.pageGroup != 1;
      },
      visibleNextButton() {
        return this.lastPageNo != this.totalPage;
      }
    },
    methods: {
      prevGroup() {
        if(this.pageGroup != 1) {
            this.goToPage(this.firstPageNo - 1);
        }
      },
      nextGroup() {
        if(this.lastPageNo != this.totalPage) {
            this.goToPage(this.lastPageNo + 1);
        } else {
            this.goToPage(this.lastPageNo);
        }
      },
      goToPage(page) {
        console.log(page);
        this.$emit('update:currentPageNo', page);
      }
    }
  }
  </script>
  
  <style scoped>
  .pagination-wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .pagination-wrapper .pagination-button {
    flex: 1;
  }

  .pagination-wrapper .page-wrapper {
    flex: 6;
    display:flex;
    justify-content: start;
  }

  .pagination-wrapper .page-wrapper .page {
    display: flex;
    justify-content: center;
    width: 10%;
  }

  .pagination-wrapper .page-wrapper .page button {
    border-radius: 50%;
    width: 2em;
    height: 2em;
  }

  .pagination-wrapper .pagination-button,
  .pagination-wrapper .page-wrapper .page button {
    border: none;
    background-color: transparent;
  }

  .pagination-wrapper .page-wrapper .page button.active {
    font-weight: bold;
    background-color: rgb(46, 46, 56);
    border: none;
    color: rgb(255, 230, 0);
  }
  </style>
  